/** "Priya Raman" -> "PR", "priya@mybusinessmate.ai" -> "PM", "" -> "?". Used for avatars. */
export function initialsOf(name: string | null | undefined, email?: string | null): string {
  const source = (name || email || '').trim();
  const parts = source.split(/[\s@.]+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '?';
}
